<template>
    <DashboardCard
            :width="width"
            :dataDisplay="dataDisplay"
            dataValueFormatFilter="currency"
            :main_icon="main_icon"
            :icons="icon_data"
            :load_url="load_url"
            :title="title">
    </DashboardCard>
</template>


<script>
    import DashboardCard from '../../widgets/DashboardCard';
    export default {
        name: 'TotalPaymentsReady',
        components: {DashboardCard},
        props: {
            width: {type:Number, default: 25},
            dataDisplay: {type:String, default: null},
        },
        data() {
            return {
                main_icon: 'fa-light fa-money-bill-alt',
                title: 'Payment Statuses',
                load_url: '/dashboards/PaymentsReady',
                icon_data: [
                    {
//                        name: 'Payments Generated Value',
                        name: 'Generated Value',
                        text_color: '#2A9D8F',
                    },
                    {
//                        name: 'Payment Generated Offers',
                        name: 'Generated Offers',
                        text_color: '#264653',
                    },
                    {
//                        name: 'Total Orders Paid',
                        name: 'Orders Paid',
                        text_color: '#F4A261',
                    },
                    {
//                        name: 'Total Returns Value',
                        name: 'Returns Value',
                        text_color: '#E76F51',
                    },
                ],
            };
        },
    };
</script>

<style scoped>

</style>